<template>
  <form @submit.prevent="submit">
    <fg-input label="Name"
      type="text"
      v-model="season.name"
      :error="valErrors['name'] ? valErrors['name'][0] : null"
    />
    <div class="form-group has-label">
      <label>Saison</label>
      <div>
        <l-radio v-model="season.season" inline label="ss">Sommersaison</l-radio>
        <l-radio v-model="season.season" inline label="ws">Wintersaison</l-radio>
        <l-radio v-model="season.season" inline label="ck">Cruise Kollektion</l-radio>
      </div>
    </div>
    <fg-input label="Jahr"
      type="text"
      v-model="season.year"
      :error="valErrors['year'] ? valErrors['year'][0] : null"
    />
    <button type="submit" class="btn btn-fill btn-info">{{ submitText }}</button>
  </form>
</template>

<script>
import { Radio as LRadio } from 'src/components'

export default {
  props: ['valErrors', 'initSeason', 'submitText'],
  components: { LRadio },
  data () {
    return {
      season: this.initSeason
    }
  },
  methods: {
    submit () {
      this.$emit('submit', this.season)
    }
  }
}
</script>

<style>
</style>
